export const JIANYING_TEMPLATE_STATUS = Object.freeze({
  CREATED: 'Created',
  SCANNED: 'Scanned',
});

export const JIANYING_TEMPLATE_RUNTIME_STATUS = Object.freeze({
  CHECKING: 'Checking',
  AVAILABLE: 'Available',
  MISSING: 'Missing',
  UNREADABLE: 'Unreadable',
  WAITING_FOR_CHECK: 'WaitingForCheck',
  NO_SCHEDULABLE_DEVICE: 'NoSchedulableDevice',
  SERVICE_OFFLINE: 'ServiceOffline',
});

const JIANYING_TEMPLATE_RUNTIME_STATUS_LABELS = Object.freeze({
  [JIANYING_TEMPLATE_RUNTIME_STATUS.CHECKING]: '检查中',
  [JIANYING_TEMPLATE_RUNTIME_STATUS.AVAILABLE]: '可用',
  [JIANYING_TEMPLATE_RUNTIME_STATUS.MISSING]: '草稿不存在',
  [JIANYING_TEMPLATE_RUNTIME_STATUS.UNREADABLE]: '草稿不可读',
  [JIANYING_TEMPLATE_RUNTIME_STATUS.WAITING_FOR_CHECK]: '等待设备检查',
  [JIANYING_TEMPLATE_RUNTIME_STATUS.NO_SCHEDULABLE_DEVICE]: '暂无可调度设备',
  [JIANYING_TEMPLATE_RUNTIME_STATUS.SERVICE_OFFLINE]: '状态读取失败',
});

export const shouldCheckJianyingTemplateAvailability = (status) =>
  status === JIANYING_TEMPLATE_STATUS.SCANNED;

export const JIANYING_TEMPLATE_STATUS_LABELS = Object.freeze({
  [JIANYING_TEMPLATE_STATUS.CREATED]: '待扫描',
  [JIANYING_TEMPLATE_STATUS.SCANNED]: '已扫描',
});

export const getJianyingTemplateStatusLabel = (
  status,
  runtimeStatus,
  availability = {},
) => {
  if (shouldCheckJianyingTemplateAvailability(status) && runtimeStatus) {
    const availableCount = Array.isArray(availability.available_device_ids)
      ? availability.available_device_ids.length
      : 0;
    const missingCount = Number(availability.missing_device_count) || 0;
    const unreadableCount = Number(availability.unreadable_device_count) || 0;
    if (
      runtimeStatus === JIANYING_TEMPLATE_RUNTIME_STATUS.AVAILABLE
      && availableCount > 0
    ) {
      return `可用（${availableCount} 台设备）`;
    }
    if (
      runtimeStatus === JIANYING_TEMPLATE_RUNTIME_STATUS.MISSING
      && missingCount > 0
    ) {
      return '在线设备均缺少该模板';
    }
    if (
      runtimeStatus === JIANYING_TEMPLATE_RUNTIME_STATUS.UNREADABLE
      && missingCount > 0
      && unreadableCount > 0
    ) {
      return `不可用（缺失 ${missingCount} 台、不可读 ${unreadableCount} 台）`;
    }
    if (
      runtimeStatus === JIANYING_TEMPLATE_RUNTIME_STATUS.UNREADABLE
      && unreadableCount > 0
    ) {
      return '模板不可读';
    }
    return JIANYING_TEMPLATE_RUNTIME_STATUS_LABELS[runtimeStatus]
      || runtimeStatus;
  }
  return JIANYING_TEMPLATE_STATUS_LABELS[status] || status || '-';
};

export const getJianyingStatusTone = (status, runtimeStatus) => {
  if (shouldCheckJianyingTemplateAvailability(status) && runtimeStatus) {
    if (runtimeStatus === JIANYING_TEMPLATE_RUNTIME_STATUS.AVAILABLE) {
      return 'success';
    }
    if (
      runtimeStatus === JIANYING_TEMPLATE_RUNTIME_STATUS.CHECKING
      || runtimeStatus === JIANYING_TEMPLATE_RUNTIME_STATUS.WAITING_FOR_CHECK
    ) {
      return 'progress';
    }
    return 'danger';
  }
  if (status === JIANYING_TEMPLATE_STATUS.SCANNED) return 'success';
  if (status === JIANYING_TEMPLATE_STATUS.CREATED) return 'muted';
  return 'progress';
};
